var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('OmniButton', {
    staticClass: "regenerate-trigger-cache",
    attrs: {
      "disabled": _vm.isProcessing || _vm.disabled
    },
    on: {
      "click": _vm.refreshCache
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "sync-alt",
      "spin": _vm.isProcessing
    }
  })], 1), _c('span', {
    staticClass: "label"
  }, [_vm._v("Systeeminstellingen cache vernieuwen")])]);

}
var staticRenderFns = []

export { render, staticRenderFns }